var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CookieJobStorageDriver_1;
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { deserializeMapFromJson, serializeMapToJson } from '@slickdeals/durango/dist/javascript/utilities/serialization';
import { name as CookieServiceName } from '../../cookies/cookieService';
import { JobContext, } from '../jobContext';
/** Name of this module */
export const name = 'CookieJobStorageDriver';
/** Unique cookie id used to represent our job queue */
const cookieKey = 'bp_job_queue';
let CookieJobStorageDriver = CookieJobStorageDriver_1 = class CookieJobStorageDriver {
    constructor(cookieService) {
        this.cookieService = cookieService;
    }
    static create(cookieService) {
        return new CookieJobStorageDriver_1(cookieService);
    }
    /**
     * Retrieve all jobs with provided topic
     * @param topic The topic associated with the jobs we want to retrieve
     * @returns An array of all jobs with provided topic
     */
    retrieveJobsByTopic(topic) {
        return this.convertCriteriaToJobs(topic);
    }
    /**
     * Retrieve all jobs in job queue
     * @returns Array of all jobs in job queue
     */
    retrieveAllJobs() {
        return this.convertCriteriaToJobs();
    }
    /**
     * Add job to job queue and set job in cookie
     * @param job The job we want to add
     * @returns Instance of CookieJobStorageDriver
     */
    persistJob(job) {
        const derivedCriteria = this.deriveJobCriteriaFromCookie();
        // Initialize the criteria bucket if it doesn't exist
        if (!derivedCriteria.has(job.getTopic())) {
            derivedCriteria.set(job.getTopic(), []);
        }
        // Grab jobs and purge the keyed jobs that match
        // We know this is going to be an array of criteria
        const foundJobs = derivedCriteria.get(job.getTopic());
        const filteredJobs = foundJobs.filter(criteria => criteria.jobKey !== job.getJobKey());
        // Push job criteria onto job queue
        filteredJobs.push(job.getCriteria());
        // Save the updated job list
        derivedCriteria.set(job.getTopic(), filteredJobs);
        // Set cookie with job criteria
        this.cookieService.setCookie({
            name: cookieKey,
            value: serializeMapToJson(derivedCriteria),
        });
        return this;
    }
    /**
     * Retrieve job from cookie
     * @returns A job criteria
     */
    deriveJobCriteriaFromCookie() {
        const currentJobs = this.cookieService.getCookie(cookieKey);
        const currentValue = currentJobs.value;
        if (typeof currentValue === 'string') {
            return deserializeMapFromJson(currentValue);
        }
        return new Map();
    }
    /**
     * Hydrates our jobs with criteria and pushed them onto a job array
     * @returns Array of jobs
     */
    convertCriteriaToJobs(topic) {
        const allCriteria = this.deriveJobCriteriaFromCookie();
        const actionable = [];
        const jobs = [];
        if (topic) {
            if (!allCriteria.has(topic)) {
                allCriteria.set(topic, []);
            }
            allCriteria.get(topic).forEach(criteria => actionable.push(criteria));
        }
        else {
            allCriteria.forEach(value => {
                value.forEach(criteria => actionable.push(criteria));
            });
        }
        actionable.forEach(criteria => {
            jobs.push(new JobContext({
                topic: criteria.topic,
                durable: criteria.durable,
                schedule: criteria.schedule,
            }).hydrateFromCriteria(criteria));
        });
        return jobs;
    }
};
CookieJobStorageDriver = CookieJobStorageDriver_1 = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
        dependencies: {
            ...Injector.createDependency(CookieServiceName, InjectorScope.Singleton),
        },
    })
], CookieJobStorageDriver);
export default CookieJobStorageDriver;
